import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/auth-slice';
import chatsReducer from './slices/chats-slice';
import presetsReducer from './slices/presets-slice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    chats: chatsReducer,
    presets: presetsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
